export default [
  {
    name: "groups",
    meta: {
      title: "Manage Groups",
    },
    path: "/manage/groups",
    component: () => import("@/views/pages/groups"),
  },
];
